import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import '@verifier-user/verifier-cdr/dist/esm/index.css'
import './index.css'
import { ApplicationContextProvider } from './contexts/appContext'
import Modal from 'react-modal'
import { breadCrumbOnClickHandler } from '@verifier-user/verifier-raygun'

window.fnfWidgetInit = ({ domElementId, vendorSettings }) => {
  Modal.setAppElement('#' + domElementId) // Replace with your app element's ID
  const appId = process.env.APP

  const settings = vendorSettings || { viewSettings: {} }

  const host = document.getElementById(domElementId)

  if (!host) {
    throw new Error(`The DOM Element with ID ${domElementId} does not exist`)
  }

  let baseUrl
  if (process.env.BASE_URL !== undefined && process.env.BASE_URL !== 'undefined') {
    baseUrl = process.env.BASE_URL + '/'
  } else {
    baseUrl = window.location.origin + '/'
  }

  const defaultCssCdnUrl = baseUrl + (process.env.NODE_ENV === 'development' ? 'css/fnf.css' : 'css/fnf.min.css')

  let shadowDom = host.shadowRoot
  if (!shadowDom) {
    shadowDom = host.attachShadow({ mode: 'open' })
  }

  // import external styles
  const externalLink = document.createElement('link')
  externalLink.rel = 'stylesheet'
  externalLink.href = defaultCssCdnUrl

  shadowDom.prepend(externalLink)

  const typeKitLink = document.createElement('link')
  typeKitLink.rel = 'stylesheet'
  typeKitLink.href = 'https://use.typekit.net/ixs4sly.css'

  shadowDom.appendChild(typeKitLink)

  const style = document.createElement('style')
  style.textContent = `body, p, div, span {
            font-family: "lato", sans-serif; /* Lato for body text */
            font-size: 16px;
            line-height: 1.6;
            font-weight: 300;
        }
    
    /* Headings and spans within headings */
    h1, h2, h3, h4 {
        font-family: "anivers", sans-serif; /* Anivers for headings */
    }
    
    h1 span, h2 span, h3 span, h4 span {
        font-family: inherit; /* Use the heading's font-family */
        font-size: inherit;   /* Ensure it matches the heading's size */
        line-height: inherit; /* Ensure it matches the heading's line height */
        font-weight: inherit; /* Match the heading's weight */
    }`

  shadowDom.appendChild(style)

  shadowDom.addEventListener('click', breadCrumbOnClickHandler)

  const renderIn = document.createElement('div')
  shadowDom.appendChild(renderIn)

  const newDiv = document.createElement('div')
  newDiv.id = appId

  host.parentElement.append(newDiv)

  const root = ReactDOM.createRoot(renderIn) // Create a root with the target DOM element

  const appContent = (
    <ApplicationContextProvider vendorSettings={settings}>
      <App />
    </ApplicationContextProvider>
  )

  if (process.env.NODE_ENV === 'development') {
    root.render(<React.StrictMode>{appContent}</React.StrictMode>)
  } else {
    root.render(appContent)
  }
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitalsß
reportWebVitals()
